import { useTranslation } from 'react-i18next'

export function Footer() {
  const { t } = useTranslation()

  return (
    <footer className='border-t border-border bg-card py-3 px-6'>
      <div className='flex items-center justify-center text-sm text-muted-foreground'>
        <p>{t('Copyright © Shigemasa CO.,Ltd 2025' as any)}</p>
      </div>
    </footer>
  )
}
